// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"c086f854","228":"60a1e29d","433":"e6c5575d","630":"740e2f1f","697":"88f4cd4a","736":"36ba278d","772":"a7c1f2e3","970":"030ffa87"}[chunkId] + ".chunk.js";
};